import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Courses from "@/pages/Courses";
import Retreats from "@/pages/Retreats";
import Facilitators from "@/pages/Facilitators";
import Booking from "@/pages/Booking";
import Therapy from "@/pages/Therapy";
import Investment from "@/pages/Investment";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster
          position="bottom-center"
          richColors
          toastOptions={{
            style: {
              fontFamily: "Outfit, system-ui, sans-serif",
              background: "#FDFBF7",
              color: "#2C221E",
              border: "1px solid rgba(44,34,30,0.08)",
              borderRadius: "16px",
            },
          }}
        />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/retreats" element={<Retreats />} />
            <Route path="/facilitators" element={<Facilitators />} />
            <Route path="/therapy" element={<Therapy />} />
            <Route path="/investment" element={<Investment />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
